import { Bot } from 'lucide-react';

export function AqlAssistantButton({
  open,
  criticalCount = 0,
  onClick
}: {
  open: boolean;
  criticalCount?: number;
  onClick: () => void;
}) {
  return (
    <button
      type="button"
      aria-label="Open VISION COPILOT"
      aria-pressed={open}
      data-demo-tour="marine-assistant"
      onClick={onClick}
      className={`aql-assistant-button fixed bottom-6 right-6 z-[82] inline-flex h-14 w-14 items-center justify-center overflow-hidden rounded-2xl border shadow-[0_18px_42px_rgba(8,145,178,0.28)] transition-all active:scale-95 ${
        open
          ? 'border-primary/45 bg-primary text-primary-foreground'
          : 'border-border bg-card/92 text-primary hover:border-primary/45 hover:bg-accent hover:text-accent-foreground'
      }`}
    >
      <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-sky-500/18 text-cyan-300 shadow-inner">
        <Bot className="h-6 w-6" aria-hidden="true" strokeWidth={2.6} />
      </span>
      {criticalCount > 0 ? (
        <span className="absolute -right-1.5 -top-1.5 flex h-5 min-w-5 items-center justify-center rounded-full border border-card bg-red-500 px-1 text-[10px] font-bold text-white">
          {criticalCount > 9 ? '9+' : criticalCount}
        </span>
      ) : null}
    </button>
  );
}
